import React from 'react';
import { motion } from 'framer-motion';
export function WhatYouGetSection() {
  return <section className="w-full bg-white py-14 md:py-[88px] px-6 lg:px-12" data-id="element-190">
      <div className="max-w-[1100px] mx-auto grid grid-cols-1 md:grid-cols-[45%_55%] gap-12 items-center" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative flex justify-center" data-id="element-192">
          <div className="absolute inset-0 bg-gradient-to-tr from-crema to-white rounded-full blur-3xl opacity-50 -z-10" data-id="element-193"></div>
          <img src="https://cdn.magicpatterns.com/uploads/pU6E1WwrC6wKn2oX29uS6U/Publidad_-02-B.png" alt="Libro Marta, Don Raúl y la IA" className="w-full max-w-md h-auto object-contain drop-shadow-[0_20px_30px_rgba(0,0,0,0.2)]" data-id="element-194" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col" data-id="element-195">
          <span className="font-sans font-bold text-[11px] text-gold uppercase tracking-wider" data-id="element-196">
            LO QUE RECIBES HOY
          </span>

          <h2 className="text-[28px] font-serif font-bold text-navy mt-2 leading-[1.3]" data-id="element-197">
            El libro que alguien debió escribir hace 3 años
          </h2>

          <p className="text-[15px] font-sans text-[#4A4A4A] mt-3 leading-[1.7]" data-id="element-198">
            Escrito como una conversación, no como un manual. Narrado como una
            novela, no como un curso. Diseñado para quien prefiere una buena
            historia antes que una lista de pasos que nunca termina de seguir.
          </p>

          <ul className="mt-6 space-y-4" data-id="element-199">
            <li className="flex items-start" data-id="element-200">
              <span className="text-gold mr-3 mt-0.5" data-id="element-201">&rarr;</span>
              <span className="text-[15px] font-sans text-[#4A4A4A] leading-[1.6]" data-id="element-202">
                121 páginas escritas como novela. Sin capítulos aburridos. Sin
                jerga que nadie te traduce.
              </span>
            </li>
            <li className="flex items-start" data-id="element-203">
              <span className="text-gold mr-3 mt-0.5" data-id="element-204">&rarr;</span>
              <span className="text-[15px] font-sans text-[#4A4A4A] leading-[1.6]" data-id="element-205">
                6 historias reales que responden las 28 preguntas que todos
                tienen pero nadie se atreve a hacer en público.
              </span>
            </li>
            <li className="flex items-start" data-id="element-206">
              <span className="text-gold mr-3 mt-0.5" data-id="element-207">&rarr;</span>
              <span className="text-[15px] font-sans text-[#4A4A4A] leading-[1.6]" data-id="element-208">
                El Diccionario de Supervivencia: los términos que todos usan y
                nadie explica — ahora en tu idioma.
              </span>
            </li>
            <li className="flex items-start" data-id="element-209">
              <span className="text-gold mr-3 mt-0.5" data-id="element-210">&rarr;</span>
              <span className="text-[15px] font-sans text-[#4A4A4A] leading-[1.6]" data-id="element-211">
                Las 3 preguntas que puedes usar HOY en cualquier conversación
                sobre IA y sonar como alguien que entiende.
              </span>
            </li>
            <li className="flex items-start" data-id="element-212">
              <span className="text-gold mr-3 mt-0.5" data-id="element-213">&rarr;</span>
              <span className="text-[15px] font-sans text-[#4A4A4A] leading-[1.6]" data-id="element-214">
                Descarga inmediata en PDF. Compatible con cualquier dispositivo.
                Lo tienes en tus manos en 2 minutos.
              </span>
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}